import React, { Component } from 'react'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import _get from 'lodash/get'
import Carousel from '@components/carousel'
import PlaylistCard from '@components/playlist-card'
import VideoCard from '@components/video-card'

import s from './original.css'

class MolaOriginal extends Component {
  state = {
    currentSlide: 0,
    viewportWidth: this.props.isMobile ? 0 : 1200,
  }

  componentDidMount() {
    if (window) {
      this.updateWindowDimensions()
      window.addEventListener('resize', this.updateWindowDimensions)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState({ viewportWidth: window.innerWidth })
  }

  handleOnClick = obj => {
    // if (obj && obj.id) {
    //   let route = this.props.setBackToPageTitle(`/watch?v=${obj.id}`)
    //   if (obj.type !== 'videos') {
    //     route = this.props.setBackToPageTitle(`/categories/${obj.id}`)
    //   }
    //   window.location.href = route
    // }
    if (this.props.onClick && obj) {
      this.props.onClick(obj)
    }
  }

  handleAfterSlide = carousel => {
    const index = _get(carousel, 'state.currentSlide', 0)
    this.setState({ currentSlide: index })
  }

  handleCarousel = height => {
    if (this.props.carouselHeightCallback) {
      this.props.carouselHeightCallback(height)
    }
  }

  render() {
    const {
        id,
        data = [],
        isMobile = false,
        logoOri,
        headerTitle,
        isLandscape,
        defaultPermissionCard,
        isRatio23,
        onClick,
        setBackToPageTitle,
      } = this.props,
      { currentSlide, viewportWidth } = this.state

    const title = _get(data, `[${currentSlide}].title`, ''),
      shortDescription = _get(data, `[${currentSlide}].shortDescription`, ''),
      // longDescription = _get(data, `[${currentSlide}].description`, ''),
      description = shortDescription || null

    const oriSlideToShow = isMobile ? (isLandscape ? 1.2 : 2.7) : isLandscape ? 2 : 4.9,
      cellSpacing = isMobile ? (isLandscape ? 45 : 0) : isLandscape ? viewportWidth * 0.013 : 0,
      bgImage =
        _get(data, `[${currentSlide}].images.cover.landscape`, '') ||
        _get(data, `[${currentSlide}]background.landscape`, '')
    const routeOri = setBackToPageTitle(`/categories/${id}`, headerTitle)
    return (
      <div className={s.original_wrapper}>
        <div className={s.original_header}>
          <img alt="mola original" src={logoOri} />
          <div className={s.original_header_text}>
            <h3>{headerTitle}</h3>
          </div>
        </div>
        {this.props.data.length > oriSlideToShow && (
          <a className={s.original_view_more} href={routeOri}>
            View All
          </a>
        )}
        {/* <div className={s.hide_content}> */}

        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            background: 'transparent linear-gradient(90deg, #00000062 0%, #000000 100%) 0% 0% no-repeat padding-box',
            overflow: 'hidden',
          }}
        >
          {' '}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              backgroundImage: `url(${bgImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              filter: 'blur(20px)',
              opacity: '0.5',
            }}
          />
        </div>
        <div className={`${s.original_content} ${s.original__portrait}`}>
          <div className={s.original_grid_detail}>
            <div className={s.original_grid_detail_text}>
              {title && <h2>{title}</h2>}
              <p>
                {description && <> {description.length > 185 ? `${description.substr(0, 185)}...` : description} </>}
              </p>
              <button onClick={() => this.handleOnClick(_get(data, `[${currentSlide}]`, ''))}>View Movie</button>
            </div>
          </div>
          <div className={`${isLandscape ? '' : s.slider__portrait} ${s.original_grid_slider}`}>
            <Carousel
              wrap={true}
              autoplay={false}
              dragging={true}
              withoutControls={false}
              slidesToShow={oriSlideToShow}
              slidesToScroll={1}
              transitionMode={isLandscape ? 'scroll3d' : 'scroll'}
              cellAlign={'left'}
              hasChevronIndicator={!isMobile}
              zoomScale={isMobile ? 0.75 : 0.85}
              opacityScale={0.25}
              cellSpacing={cellSpacing}
              framePadding={this.props.framePadding}
              afterSlideCallback={this.handleAfterSlide}
              carouselHeightCallback={this.handleCarousel}
            >
              {this.props.data.length > 0 &&
                this.props.data.map((obj, index) => {
                  const image = _get(obj, 'images.cover.landscape', '') || _get(obj, 'background.landscape', '')
                  const ribbon = this.props.getRibbon ? this.props.getRibbon(obj, 1) : null
                  if (isLandscape) {
                    return (
                      <PlaylistCard
                        {...obj}
                        transitionMode={'scroll3d'}
                        key={obj.id}
                        alt={obj.title}
                        src={`${image}?w=480`}
                        srcset={`${image}?w=368 368w,${image}?w=450 450w,${image}?w=640 640w, ${image}?w=768 768w, ${image}?w=960 960w`}
                        sizes="(min-width: 768px) 30vw, 260px"
                        isDetailHidden
                        defaultPermissionCard={defaultPermissionCard}
                        onHoverBorder={false}
                        permission={false}
                        onClick={() => this.handleOnClick(_get(data, `[${currentSlide}]`, ''))}
                        ribbon={ribbon}
                      />
                    )
                  } else {
                    const image = _get(obj, 'images.cover.portrait', '') || _get(obj, 'background.portrait', '')
                    const mobileSizeQuery = isRatio23 ? 'w=180&h=270' : 'w=270&h=480'
                    //   desktopSizeQuery = isRatio23 ? 'w=400&h=600' : 'w=450&h=800'
                    // const imgSizeQuery = isMobile ? mobileSizeQuery : desktopSizeQuery
                    const ribbon = this.props.getRibbon ? this.props.getRibbon(obj, isRatio23 ? 3 : 2) : null

                    const imgSize = {
                      src: `${image}?${mobileSizeQuery}`,
                      srcset: isRatio23
                        ? `${image}?w=180&h=270 180w, ${image}?w=400&h=600 400w, ${image}?w=640&h=960 640w, ${image}?w=720&h=1080 720w`
                        : `${image}?w=270&h=480 270w, ${image}?w=450&h=800 450w, ${image}?w=540&h=960 540w, ${image}?w=720&h=1280 720w`,
                      sizes: '(min-width: 1024px) 15vw, 100px',
                    }
                    return (
                      <VideoCard
                        {...obj}
                        transitionMode={'scroll3d'}
                        key={obj.id}
                        alt={obj.title}
                        // src={`${image}?${imgSizeQuery}`}
                        src={imgSize.src}
                        srcset={imgSize.srcset}
                        sizes={imgSize.sizes}
                        isDetailHidden
                        defaultPermissionCard={defaultPermissionCard}
                        onHoverBorder={false}
                        permission={false}
                        isRatio23={isRatio23}
                        onClick={() => this.handleOnClick(_get(data, `[${currentSlide}]`, ''))}
                        ribbon={ribbon}
                      />
                    )
                  }
                })}
            </Carousel>
          </div>
        </div>
      </div>
      // </div>
    )
  }
}

export default withStyles(s)(MolaOriginal)
